<template>
    <div class="markdown-report" v-loading="isLoading">
        <div class="awr-analysize-report-content markdown-content" v-html="compiledMarkdown"></div>
    </div>
</template>

<script>
    let marked = require('marked');
    export default {
        name: "user-markdown-report",
        data(){
            return {
                markRender: new marked.Renderer(),
                context: "",
                isLoading: false,
                btnShow: false,
                btnLoading: false,
                imageURL: `/static/awr`,
            }
        },
        computed: {
            compiledMarkdown(){
                let id = this.$route.params.history_id;
                let imageURL = this.imageURL;
                let index = 0;
                this.markRender.heading = function(text, level) {
                    if (level <= 4 && level >= 2) {
                        return `<h${level} id="${index++}" class="jump" >${text}</h${level}>`;
                    } else {
                        return `<h${level}>${text}</h${level}>`;
                    }
                };
                this.markRender.image = function(href,title,text) {
                    return `<img src="${`${imageURL}/${id}/${href.slice(2)}`}" />`
                };
                return marked(this.context);
            },
        },
        methods: {
            $_init(){
                marked.setOptions({
                    renderer: this.markRender,
                    gfm: true,
                    tables: true,
                    breaks: false,
                    pedantic: false,
                    sanitize: false,
                    smartLists: true,
                    smartypants: false,
                });
            },
            $_get: async function(){
                this.isLoading = true;
                this.btnShow = false;
                let params = {
                    history_id: this.$route.params.history_id,
                }
                let data = await this.$api.userAwrUnscramble.getReport.report.call(this, params);
                if(data !== false) {
                    this.$_getFile(data.items);
                }
                this.isLoading = false;
            },
            $_getFile: async function(url){
                let params = {
                    url: url
                }
                let data = await this.$api.userAwrUnscramble.getFile.call(this, params);
                if(data !== false) {
                    this.context = data;
                    if(window.location.hash){
                        window.setTimeout(()=>{
                            window.location.href = window.location.hash;
                        },100);
                    }
                    this.btnShow = true;
                }
            },
            $_download: async function(){
                this.btnLoading = true;
                let params = {
                    id: this.$route.params.history_id,
                    type: 1,
                }
                let data = await this.$api.awrReport.analysisReport.download.call(this, params);
                if(data !== false) {
                    this.btnLoading = false;
                    this.$message.success("下载成功.");
                }
            },
        },
        created(){
            this.$_init();
            this.$_get();
        },
        mounted(){
        },
    }
</script>

<style lang="less">
    @import url("../../../style/markdown.less");
    .markdown-report {
        width: 100%;
        background-color: #f3f2ee;
        padding: 80px 0;
        position: relative;
        .awr-analysize-report-content {
            width: 100%;
            max-width: 1000px;
            margin: 0 auto;
            background-color: #f3f2ee;
            min-height: 500px;
            color: rgb(51, 51, 51);
            line-height: 1.6;
        }
    }
</style>